export default __webpack_public_path__ + "static/media/1796.2050b1ee.png";